module.exports = __webpack_public_path__ + "static/media/7.9843c3e4.jpg";